import React, { Component }  from 'react'
import { connect } from 'react-redux'

import {transactionEx} from 'selectors/transactions'

let select = (state, props) => ({
	transaction: transactionEx(state, props.transactionID)
})

export class StatusIcon extends Component{
	render(){
		let { props } = this
		return(
			!props.transaction ? <div></div>
			:<div style={{textAlign:"center"}}>

				{(props.transaction.type && props.transaction.type.indexOf('transaction/invoice-payment')!==-1)?<svg
					viewBox="0 0 100 76"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					style={{
						width: "25px"
						, position: "relative"
						, top: "3px"
						, left: "0px"
					}}
				>
					<title>properties</title>
					<defs></defs>
					<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="properties" fill="#3cd2ae">
							<path d="M56.8,0.92a24.5,24.5,0,1,0,24.5,24.5A24.48,24.48,0,0,0,56.8.92Zm7.1,34.2a7.84,7.84,0,0,1-4.1,2.6,1.2,1.2,0,0,0-1,1.3v2.2a0.9,0.9,0,0,1-1,1H55.5a0.93,0.93,0,0,1-1-1.1v-1.6c0-1.2,0-1.2-1.2-1.4a16.6,16.6,0,0,1-4.2-1.2c-1-.5-1.1-0.8-0.8-1.8a21.72,21.72,0,0,1,.7-2.4c0.2-.6.4-0.8,0.7-0.8a1.33,1.33,0,0,1,.7.3,12.89,12.89,0,0,0,4.6,1.4c0.3,0,.6.1,0.8,0.1a4.19,4.19,0,0,0,2.2-.5,2.35,2.35,0,0,0,.6-4.1,9.5,9.5,0,0,0-1.7-1A39.58,39.58,0,0,1,52.2,26c-2.4-1.5-4-3.4-3.8-6.4,0.2-3.3,2.1-5.4,5.1-6.5,1.3-.5,1.3-0.4,1.3-1.8V10c0-1,.2-1.2,1.2-1.2h1.1c1.9,0,1.9.1,1.9,2.1,0,1.5,0,1.5,1.5,1.7a13.85,13.85,0,0,1,3.3,1,1,1,0,0,1,.6,1.3c-0.3.9-.5,1.8-0.8,2.7a1,1,0,0,1-.7.8,2.54,2.54,0,0,1-.7-0.2,10.61,10.61,0,0,0-4.6-1H57a3.53,3.53,0,0,0-1.4.3,2,2,0,0,0-.5,3.5,12.56,12.56,0,0,0,2.3,1.3,30.5,30.5,0,0,1,4.1,1.9A7.07,7.07,0,0,1,63.9,35.12Zm30.4,20.3c-1.8-.1-5.6,2-6.7,2.5a116.5,116.5,0,0,0-12.2,7.4,2.18,2.18,0,0,1-.8.5,14.27,14.27,0,0,1-4.9,2.1c-9.8,2.2-24.1,2.4-24.1,2.4H44.8a1.3,1.3,0,0,1-1.3-1,1.24,1.24,0,0,1,1.1-1.4l21.2-2.1a4.68,4.68,0,0,0-1-9.3l-18.9-.2a18.32,18.32,0,0,1-4.6-.7c-12.2-3.7-19-.2-22.7,1.4a4.46,4.46,0,0,0-4.1-2.2l-7.8.6a5,5,0,0,0-4.6,5.2l1.3,18.8A5,5,0,0,0,8.6,84l8.1-.6a4.26,4.26,0,0,0,3.7-2.7l35.7,1.6a18.78,18.78,0,0,0,11.2-2l1-.6,27-16.4a4.59,4.59,0,0,0,2.3-3.8A3.43,3.43,0,0,0,94.3,55.42ZM11.6,79.52a2.8,2.8,0,1,1,2.8-2.8A2.73,2.73,0,0,1,11.6,79.52Zm62.2-21.2c2.8-1.6,8.4-4.4,11.5-5.7a4.36,4.36,0,0,1,4.4.4,29.17,29.17,0,0,0-3.1,1.4A130.77,130.77,0,0,0,75,61.22a5.55,5.55,0,0,0-.8.6v-1.6a10.62,10.62,0,0,0-.4-1.9h0Zm-3.7-4.7c1.9-1,6.1-2.4,7.9-3.2a4.36,4.36,0,0,1,4.4.4c-2.2,1-6.4,2.6-8.4,3.7l-1.4.8a1.38,1.38,0,0,1-.4.3A8,8,0,0,0,70.1,53.62Z" id="Shape"></path>
						</g>
					</g>
				</svg>
				:<img width="20px" src={(props.transaction.type && props.transaction.type.indexOf('invoice')==-1)
					?props.transaction.isPaid !="true"
						?"/manager/static/img/transactions_wallet_red.png"
						:"/manager/static/img/transactions_wallet_red_done.png"
					:(props.transaction.balance<=0 && props.transaction.paymentsAmount > 0) || (props.transaction.isPaid && props.transaction.isPaid.toString() =="true")
						?"/manager/static/img/transactions_wallet_green_done.png"
						:"/manager/static/img/transactions_wallet_green.png"}
				alt="status" title={(!(props.transaction.type && props.transaction.type.indexOf('invoice')))
					?props.transaction.isPaid !="true"
						?"Unpaid bill"
						:"Paid bill"
					:props.transaction && props.transaction.balance<=0
						?"Paid invoice"
						:"Unpaid invoice"}
				/>}

			</div>
		)
	}
}
export default connect(select)(StatusIcon)
//"/manager/static/img/transactions_wallet_red.png"}
//"/manager/static/img/transactions_wallet_green_done.png"}
//"/manager/static/img/transactions_wallet_red_done.png"}



// WEBPACK FOOTER //
// ./src/routes/manager/transactions/StatusIcon.js